{
  "name": "flowrunner-cli",
  "version": "0.1.1",
  "description": "Flowrunner CLI for deploying Custom Extensions",
  "bin": {
    "flowrunner": "./bin/flowrunner.js"
  },
  "main": "./dist/index.js",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "default": "./dist/index.js"
    },
    "./runtime": {
      "types": "./runtime/index.d.ts",
      "default": "./runtime/index.js"
    },
    "./package.json": "./package.json"
  },
  "scripts": {
    "build": "node scripts/build.mjs && npm run ts",
    "pack-ai-docs": "node scripts/pack-ai-docs.mjs",
    "dev": "tsx --require tsconfig-paths/register src/index.ts",
    "ts": "tsc --noEmit",
    "test": "jest --coverage --detectOpenHandles",
    "check": "npm run ts && npm run test",
    "prepack": "npm run build"
  },
  "dependencies": {
    "@types/node": "^20.0.0",
    "adm-zip": "^0.5.16",
    "archiver": "^7.0.0",
    "commander": "^12.0.0",
    "form-data": "^4.0.0",
    "jsdoc": "^4.0.0",
    "node-fetch": "^2.7.0",
    "requizzle": "^0.2.4",
    "zod": "^4.6.2"
  },
  "devDependencies": {
    "@asteasolutions/zod-to-openapi": "^8.4.0",
    "@flowrunner/flow-extension-runner": "*",
    "@flowrunner/jsdoc-parser": "*",
    "@types/adm-zip": "^0.5.7",
    "@types/archiver": "^6.0.0",
    "@types/node-fetch": "^2.6.0",
    "esbuild": "^0.24.2",
    "nock": "^14.0.17",
    "query-string": "^7.1.3",
    "tsconfig-paths": "^4.2.0",
    "tsx": "^4.0.0",
    "typescript": "^5.4.0"
  },
  "files": [
    "dist",
    "bin",
    "runtime",
    "templates",
    "project-files",
    "ai-docs"
  ],
  "types": "./dist/index.d.ts"
}
